import React,{useEffect,useState} from 'react'
import Axios from 'axios'
import Slot from '../Slot'
import moment from 'moment';
import {makeStyles } from '@material-ui/core';
import 'bootstrap/dist/css/bootstrap.min.css';
import Tradecodes from '../Tradecodes'
import { Spinner } from 'react-bootstrap';
import { Grid } from '@mui/material';
import { Dropdown } from 'semantic-ui-react'
import { ButtonContent, Placeholder, Search, Icon} from "semantic-ui-react";
import { IReq } from '../../../../app/models/req';
import Priorites from '../Priorities';
import { copyFileSync } from 'fs';

import config from '../../../../app/api/apiconfig';

const baseURL = config.app.baseUrl
const schedulingbaseUrl = config.app.schedulingbaseUrl


const useStyles = makeStyles((theme) => ({   
    Container: {
        margin: "0 auto"
    },
    Spinner: {
        position: "fixed",
        top: "50%",
        left: "50%",
    },
    Dropdown: {
        paddingBottom: "10px",
        backgroundColor: "red"
    },
    H2:{
        textAlign: "center",
        margin:"0 auto",
        width: "100%"
    },
    Tradecode: {
        marginBottom: "15px",
        marginTop: "15px"

    },
    SearchContainer: {
        width: "100%",
        display:"flex"
    },
    SearchIcon: {
        paddingTop: "5px"
    }


}));


export default function RKAvailabilityDash(props) {


    
    const classes = useStyles();
    const [resourcedata,setresourceData] = useState([]);
    const [loading,setLoading] = useState(false);
    const [query, setQuery] = useState("");
    const [jobData,setJobData] = useState([]);
    const [finalTrade,setFinalTrade] = useState("");
    const [prioritySelected,setPrioritySelected] = useState(false);
    const [priority,setPriority] = useState("");
    const [prioritySpecificData,setPrioritySpecificData] = useState([]);

    function handleSearch(event){
        let value = event.target.value.toLowerCase();
        setQuery(value);
    }

    function getAvailability(res,tradecode){
        
        const request = {
            ClientID: "RK01", Duration: 60, Priority: priority, ReturnedSlots: 100, TradeCode: tradecode, DateRaised: res.DateRaised, PostCode: res.PostCode, TargetDate: res.TargetDate, WorkorderId: res.workorderId
        }
        let getavailurl = schedulingbaseUrl + "getAvailability" 
        var JsonRequest = request

        //Axios.post("https://lookaheadintegrationapi.azurewebsites.net/api/Scheduling/getAvailability",JsonRequest)
        Axios.post(getavailurl,JsonRequest)
            .then(response => {
                console.log(response.data)
                filterData(response.data)
                setLoading(false)
        })
    }
    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
      }


    const filterData = (data) => {
        var days = 0;
        
        switch(priority){
            case "Routine":
                days = 20;
                returnArrayInRangeOfDates(data,days);
                break;
               
            case "Urgent":
                days = 5;
                returnArrayInRangeOfDates(data,days);
                break;
        }   
    }
    
    const returnArrayInRangeOfDates = (data, days) => {
        var today = new Date();
        var endDate = addDays(today, days);
        console.log("Today: " + today);
        console.log("End Date: " + endDate);
        
        setPrioritySpecificData(
            data.filter(x => {
                var slotStart = moment(x["Start"]);
                // Exclude slots with a start time of exactly 16:00
                return slotStart.hour() !== 16;
            })
        );
    }


    useEffect(() => {
        
        var tempTrade = props.location.search;
        var tc = tempTrade.substring(tempTrade.indexOf('=') + 1);

        if(tc === undefined || tc == null || tc =="null"){
            setPriority("Routine");
        } 
        else 
        {
            setFinalTrade(tc)
        }
        if(tempTrade != null && prioritySelected){
            setLoading(true)
            getData(tc);
        }
        
    }, [prioritySelected,priority])

    function findJobByJobNumber(jobNumber,tradecode) {
        let getjoburl = schedulingbaseUrl + "getJobByNumber?jobNumber=" 

        //Axios.post("https://lookaheadintegrationapi.azurewebsites.net/api/Scheduling/getJobByNumber?jobNumber=" + jobNumber)
        Axios.post(getjoburl + jobNumber)
        .then(response => {
            setJobData(response.data)
           getAvailability(response.data,tradecode)
        })
    }
        
    function getData(tradecode){
        try
        {
            findJobByJobNumber(props.match.params.JobNumber,tradecode)
        }
        catch(ex){
            console.error("An error has occurred: " + ex)
        }
    }
    const handleSelect=async (event,data)=>{
        
            const tradecode = data.value;
            setFinalTrade(tradecode)
            setLoading(true)
            getData(tradecode)
        }

    const handlePriority=async (event,data)=>{      
        if(priority !== data.value){
            setPriority(data.value);
            setPrioritySelected(true)
        }
      }


    return (
    <div className={classes.Container}>
        <h2 className={classes.H2}>Showing Availability Slots for {props.match.params.JobNumber}</h2>

        <Dropdown
            
            placeholder='Select a Priority'
            fluid
            search
            selection
            onChange={handlePriority}
            options={Priorites}
            value={priority}
        />

        <Dropdown
            className={classes.Tradecode}
            placeholder='Select a Tradecode'
            fluid
            search
            selection
            onChange={handleSelect}
            options={Tradecodes}
            value={finalTrade.toLowerCase()}
        />

        <Grid 
            container 
            spacing={2}
            alignItems="center"
            columns={{ xs: 6, sm: 6, md: 6, xl: 6 }}
        >

            {
            
            loading ? <Spinner className={classes.Spinner} animation="border" /> :  prioritySpecificData.map((item, i) =>(

            <Grid item xs={2} sm={2} md={2} xl={2} key={i}>

            <Slot 
                jobdata={jobData}
                resourcedata={prioritySpecificData[i]}
                startTime={item['Start']}
                endTime={item['End']}
                showDayperiod = "AMPM"
            />

            
            </Grid>
            
            )) 
        }
            
            
            
            </Grid>
        
    </div>
 )}



